// BEGIN FILE: src/utils/supabaseClient.ts
import { createClient } from '@supabase/supabase-js';

// Support CRA, Vite, Next — whichever you're using.
const g: any = globalThis as any;
const SUPABASE_URL =
  (process.env.REACT_APP_SUPABASE_URL as string) ||
  g?.importMeta?.env?.VITE_SUPABASE_URL ||
  (process.env.NEXT_PUBLIC_SUPABASE_URL as string) ||
  '';

const SUPABASE_ANON_KEY =
  (process.env.REACT_APP_SUPABASE_ANON_KEY as string) ||
  g?.importMeta?.env?.VITE_SUPABASE_ANON_KEY ||
  (process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY as string) ||
  '';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // eslint-disable-next-line no-console
  console.error(
    [
      '[supabaseClient] Missing Supabase env config.',
      'Expected one of:',
      '  CRA: REACT_APP_SUPABASE_URL, REACT_APP_SUPABASE_ANON_KEY',
      '  Vite: VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY',
      '  Next: NEXT_PUBLIC_SUPABASE_URL, NEXT_PUBLIC_SUPABASE_ANON_KEY',
      'Add them to your .env.local and restart dev server.'
    ].join('\n')
  );
}
// In test or local without env, create a no-op client using a localhost URL
// so that module import does not throw. Consumers should still guard calls
// (as in components) when env is not configured.
const EFFECTIVE_URL = SUPABASE_URL || 'http://localhost:54321';
const EFFECTIVE_KEY = SUPABASE_ANON_KEY || 'anon-key';

export const supabase = createClient(EFFECTIVE_URL, EFFECTIVE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined
  }
});

// DEV: expose for console probing
if (typeof window !== 'undefined') {
  (window as any).__supabase = supabase;
  (window as any).__SUPABASE_ENV = {
    SUPABASE_URL,
    SUPABASE_ANON_KEY_SET: Boolean(SUPABASE_ANON_KEY),
  };
}
// END FILE: src/utils/supabaseClient.ts
